import React from 'react';
import ArticleTable from '../componenents/Tables/ArticleTable';
import AuthMessage from '../componenents/Messages/AuthMessage';

const ArticlePage = () => {
  return (
    <div>
      <h1>Articles</h1>
     
      <ArticleTable />
    </div>
  );
};

export default ArticlePage;
